module.exports = __webpack_public_path__ + "static/media/pacing-large@2x.6606b8a1.png";